import { useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';
import './message-box.css';

export interface MessageBoxProps {
  content: string;
  onClose?: () => void;
};

const messageBoxId = uuidv4();

const MessageBox = (props: MessageBoxProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const onCloseClick = () => {
    HideMessageBox();
    if (props.onClose) {
      props.onClose();
    }
  }

  return (
    <div
      id={messageBoxId}
      ref={containerRef}
      className="message-box visibility-hidden">
      
      <div className="content">{props.content}</div>
      <div>
        <button
          id="closeButton"
          onClick={onCloseClick}
          className="close-button"
          aria-label="Close this message box">
            &#x2716;
        </button>
      </div>
    </div>
  );
};

export default MessageBox;
export function ShowMessageBox() {
  const messageBox = document.getElementById(messageBoxId);
  if (messageBox) {
    messageBox.classList.remove(...["visibility-hidden"]);
  }
}
export function HideMessageBox() {
  const messageBox = document.getElementById(messageBoxId);
  if (messageBox) {
    messageBox.classList.add(...["visibility-hidden"]);
  }
}
